module.exports = ".case-info .row{\r\n    padding:10px 0px 0px;\r\n}\r\n\r\n.case-info .row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.case-info label{\r\n    color:grey;\r\n}\r\n\r\n.case-info label span{\r\n    color:black;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/query/query.component.css
// module id = ./src/app/legal/query/query.component.css
// module chunks = main